import { getItemByKeyValue } from '../../helpers'

export interface SiteState {
  selected: SiteAccount | null
}

export const initialState = {
  selected: null,
}

export const site = (
  state: SiteState = initialState,
  action: ReduxAction,
): SiteState => {
  switch (action.type) {
    case 'GET_SELECTED_ACCOUNT':
      return {
        ...state,
        selected: {
          ...action.payload,
        },
      }
    case 'GET_USER_LIST': {
      const { pendingUserList, permissionList } = action.payload

      if (state.selected === null) {
        return {
          ...state,
        }
      }

      const modPermissionList = state.selected.permissionList
        ? permissionList.map((item) => {
            const found = getItemByKeyValue(
              state.selected?.permissionList || [],
              'userID',
              item.userID,
            )

            if (found && found.lastLogin) {
              return {
                ...item,
                lastLogin: found.lastLogin,
                email: found.email,
              }
            }

            return item
          })
        : permissionList

      return {
        ...state,
        selected: {
          ...state.selected,
          pendingUserList,
          permissionList: modPermissionList,
        },
      }
    }
    default:
      return state
  }
}
